<template>
  <div class="safety">
    <!-- 登录密码 -->
    <div class="item_line">
      <div>
        <span class="span1">{{pc_lang.Login_password2}}</span>
        <span class="span2">{{pc_lang.A5bpay_Password_to_login}}</span>
        <router-link to="/user/resetPassword" tag="span" class="span3">{{pc_lang.Reset}}</router-link>
      </div>
    </div>
    <!-- 支付密码 -->
    <div class="item_line">
      <div>
        <span class="span1">{{pc_lang.Payment_password}}</span>
        <span class="span2">{{pc_lang.Password_needed_when_editing_info}}</span>
        <router-link to="/user/resetPayPassword" tag="span" class="span3">{{pc_lang.Reset}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'UserSafety',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  async mounted() {

  },
  created() {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.safety{

  .item_line{
    >div{
      display: flex;
      align-items: center;
      padding: 0 10px;
      >span{
        &.span1{
          width: 240px;
          font-weight: 600;
        }
        &.span2{
          flex: 1;
          padding-right: 40px;
          color: #999;
        }
        &.span3{
          color: $blue;
          cursor: pointer;
        }
      }
    }
  }
}
</style>